/**
 * A Storyblok image size field ("44", "24px") as a pixel count, or
 * `undefined` when it is empty or not a positive number.
 */
export const imageDimension = (
	value: string | number | null | undefined
): number | undefined => {
	const parsed = Number.parseFloat(String(value ?? ""));
	return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
};
